<script setup>
import { useCartStore } from '@/stores/Cart'

const cart = useCartStore()
const { formatUSD } = useFormatters()
const staticURLImg = useRuntimeConfig().public.staticURLImg

// Props for product
const props = defineProps({
    product: {
        type: Object,
        default: null,
    },
})

const currentPrice = computed(() => {
    if (props.product && props.product.productPrices.totalCount > 0) {
        return props.product.productPrices.edges[0].node.price
    } else {
        return props.product.price
    }
})
</script>

<template>
    <v-card variant="flat" class="d-flex flex-column st-card st-box-shadow">
        <nuxt-link :to="'/shop/' + product.handle" class="text-decoration-none" :aria-label="`Explore ${product.name}`">
            <v-img id="cardImg" :src="staticURLImg + product.productImages.edges[0]?.node.source" :alt="product.name">
                <v-container class="h-50 px-2 pt-0 d-flex justify-start align-start text-grey-lighten-3">
                    <span
                        v-if="currentPrice > 0 && currentPrice != product.price"
                        class="px-3 pb-4 bg-secondary text-button st-sales-badge"
                        >Sale</span
                    >
                    <v-spacer></v-spacer>
                    <span>
                        <v-chip density="compact" class="st-chip-category">
                            {{ product.category.name }}
                        </v-chip>
                    </span>
                </v-container>
            </v-img>
        </nuxt-link>
        <v-row no-gutters>
            <v-col>
                <v-spacer></v-spacer>
                <app-button
                    icon
                    :btn-icon="`mdi-cart-plus`"
                    :show-tooltip="true"
                    :tooltip-text="`Add to Cart`"
                    @click.stop="cart.addProduct(product)"
                    class="mt-n3 mr-2 d-flex justify-end"
                    aria-label="Add to Cart"
                />
            </v-col>
        </v-row>

        <v-card-title class="pt-0 pb-1 text-wrap">
            {{ product.name }}
        </v-card-title>
        <v-card-subtitle class="pb-1 font-weight-medium">{{ product.tagline }}</v-card-subtitle>
        <v-card-text class="text-subtitle-1 font-weight-medium">
            <span :class="currentPrice > 0 && currentPrice != product.price ? 'text-decoration-line-through' : null">
                {{ formatUSD(product.price) }}
            </span>
            <span>&nbsp;</span>
            <!-- <v-spacer></v-spacer> -->
            <span v-if="currentPrice > 0 && currentPrice != product.price" class="px-2 bg-secondary rounded-pill">
                {{ formatUSD(currentPrice) }}
            </span>
        </v-card-text>
        <!-- <v-card-actions class="justify-space-between">
            <app-button
                :to="`/shop/${product.handle}`"
                :btn-text="`Explore Now`"
                :variant="`text`"
                :append-icon="`mdi-chevron-right`"
                :aria-label="`Explore ${product.name}`"
            />
        </v-card-actions> -->
    </v-card>
</template>

<style scoped></style>
